export const footerLinks = {
    'gb-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://www.wingie.co.uk/flights/to-dublin/',
                    title: 'Dublin',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/to-edinburgh/',
                    title: 'Edinburgh',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/to-belfast/',
                    title: 'Belfast',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/to-amsterdam/',
                    title: 'Amsterdam',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/to-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/to-tenerife/',
                    title: 'Tenerife',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://www.wingie.co.uk/flights/be-belgium/',
                    title: 'Belgium',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/de-germany/',
                    title: 'Germany',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/gr-greece/',
                    title: 'Greece',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/ie-ireland/',
                    title: 'Ireland',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://www.wingie.co.uk/flights/airlines/british-airways/',
                    title: 'British Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/airlines/easyjet/',
                    title: 'easyJet',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/airlines/ryanair/',
                    title: 'Ryanair',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/airlines/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/flights/airlines/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/a-dublin/',
                    title: 'Dublin',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/a-edinburgh/',
                    title: 'Edinburgh',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/a-belfast/',
                    title: 'Belfast',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/a-amsterdam/',
                    title: 'Amsterdam',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/a-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/a-tenerife/',
                    title: 'Tenerife',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/be-belgium/',
                    title: 'Bélgica',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/fr-france/',
                    title: 'Francia',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/de-germany/',
                    title: 'Alemania',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/ie-irlanda/',
                    title: 'İrlanda',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/companias-aereas/british-airways/',
                    title: 'British Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/companias-aereas/easyjet/',
                    title: 'easyJet',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/companias-aereas/ryanair/',
                    title: 'Ryanair',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/companias-aereas/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/companias-aereas/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/es/vuelos/companias-aereas/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.co.uk/de/flug/nach-dublin/',
                    title: 'Dublin',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/nach-edinburgh/',
                    title: 'Edinburgh',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/nach-belfast/',
                    title: 'Belfast',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/nach-amsterdam/',
                    title: 'Amsterdam',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/nach-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/nach-teneriffa-insel/',
                    title: 'Teneriffa-Insel',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.co.uk/de/flug/be-belgien/',
                    title: 'Belgien',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/de-deutschland/',
                    title: 'Deutschland',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/gr-griechenland/',
                    title: 'Griechenland',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/in-indien/',
                    title: 'Indien',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/ie-irlanda/',
                    title: 'İrlanda',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.co.uk/de/flug/airlines/british-airways/',
                    title: 'British Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/airlines/easyjet/',
                    title: 'easyJet',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/airlines/ryanair/',
                    title: 'Ryanair',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/airlines/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/de/flug/airlines/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.co.uk/ru/flights/to-dublin/',
                    title: 'Дублин',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/to-edinburgh/',
                    title: 'Эдинбург',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/to-belfast/',
                    title: 'Белфаст',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/to-amsterdam/',
                    title: 'Амстердам',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/to-new-york/',
                    title: 'Нью-Йорк',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/to-tenerife/',
                    title: 'Тенерифе',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.co.uk/ru/flights/be-belgium/',
                    title: 'Бельгия',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/de-germany/',
                    title: 'Германия',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/gr-greece/',
                    title: 'Греция',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/ie-irlanda/',
                    title: 'İrlanda',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.co.uk/ru/flights/airlines/british-airways/',
                    title: 'British Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/airlines/easyjet/',
                    title: 'easyJet',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/airlines/ryanair/',
                    title: 'Ryanair',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/airlines/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/ru/flights/airlines/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.co.uk/ar/flights/to-dublin/',
                    title: 'دبلن',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/to-edinburgh/',
                    title: 'أدنبرة',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/to-belfast/',
                    title: 'بلفاست',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/to-amsterdam/',
                    title: 'أميستردام',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/to-new-york/',
                    title: 'نيويورك',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/to-tenerife/',
                    title: 'تينيريفي',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.co.uk/ar/flights/be-belgium/',
                    title: 'بلجيكا',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/fr-france/',
                    title: 'فرنسا',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/de-germany/',
                    title: 'ألمانيا',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/gr-greece/',
                    title: 'اليونان',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/in-india/',
                    title: 'الهند',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/ie-irlanda/',
                    title: 'İrlanda',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.co.uk/ar/flights/airlines/british-airways/',
                    title: 'الخطوط الجوية البريطا',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/airlines/easyjet/',
                    title: 'ايزي جيت',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/airlines/ryanair/',
                    title: 'رايان اير',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/airlines/lufthansa/',
                    title: 'لوفتهانزا',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/airlines/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/ar/flights/airlines/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-it': [
        {
            title: 'Destinazioni principali',
            items: [
                {
                    href: 'https://www.wingie.co.uk/it/flights/to-dublin/',
                    title: 'Dublino',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/to-edinburgh/',
                    title: 'Edimburgo',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/to-belfast/',
                    title: 'Belfast',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/to-amsterdam/',
                    title: 'Amsterdam',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/to-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/to-tenerife/',
                    title: 'Tenerife',
                },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                {
                    href: 'https://www.wingie.co.uk/it/flights/be-belgium/',
                    title: 'Belgio',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/fr-france/',
                    title: 'Francia',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/de-germany/',
                    title: 'Germania',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/ie-ireland/',
                    title: 'Irlanda',
                },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                {
                    href: 'https://www.wingie.co.uk/it/flights/airlines/british-airways/',
                    title: 'British Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/airlines/easyjet/',
                    title: 'easyJet',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/airlines/ryanair/',
                    title: 'Ryanair',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/airlines/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/it/flights/airlines/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-fr': [
        {
            title: 'Principales destinations',
            items: [
                {
                    href: 'https://www.wingie.co.uk/fr/flights/to-dublin/',
                    title: 'Dublin',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/to-edinburgh/',
                    title: 'Édimbourg',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/to-belfast/',
                    title: 'Belfast',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/to-amsterdam/',
                    title: 'Amsterdam',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/to-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/to-tenerife/',
                    title: 'Tenerife',
                },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                {
                    href: 'https://www.wingie.co.uk/fr/flights/be-belgium/',
                    title: 'Belgique',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/de-germany/',
                    title: 'Allemagne',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/gr-greece/',
                    title: 'Grèce',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/in-india/',
                    title: 'Inde',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/ie-ireland/',
                    title: 'Irlande',
                },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                {
                    href: 'https://www.wingie.co.uk/fr/flights/airlines/british-airways/',
                    title: 'British Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/airlines/easyjet/',
                    title: 'easyJet',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/airlines/ryanair/',
                    title: 'Ryanair',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/airlines/lufthansa/',
                    title: 'Lufthansa',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/airlines/eastern-airways/',
                    title: 'Eastern Airways',
                },
                {
                    href: 'https://www.wingie.co.uk/fr/flights/airlines/loganair/',
                    title: 'Loganair',
                },
            ],
        },
    ],
    'gb-pt': [
        {
            title: 'Principais destinos',
            items: [
                { href: 'https://www.wingie.co.uk/pt/flights/to-dublin/', title: 'Dublin' },
                { href: 'https://www.wingie.co.uk/pt/flights/to-edinburgh/', title: 'Edimburgo' },
                { href: 'https://www.wingie.co.uk/pt/flights/to-belfast/', title: 'Belfast' },
                { href: 'https://www.wingie.co.uk/pt/flights/to-amsterdam/', title: 'Amsterdã' },
                { href: 'https://www.wingie.co.uk/pt/flights/to-new-york/', title: 'Nova York' },
                { href: 'https://www.wingie.co.uk/pt/flights/to-tenerife/', title: 'Tenerife' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { href: 'https://www.wingie.co.uk/pt/flights/be-belgium/', title: 'Bélgica' },
                { href: 'https://www.wingie.co.uk/pt/flights/fr-france/', title: 'França' },
                { href: 'https://www.wingie.co.uk/pt/flights/de-germany/', title: 'Alemanha' },
                { href: 'https://www.wingie.co.uk/pt/flights/gr-greece/', title: 'Grécia' },
                { href: 'https://www.wingie.co.uk/pt/flights/in-india/', title: 'Índia' },
                { href: 'https://www.wingie.co.uk/pt/flights/ie-ireland/', title: 'Irlanda' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { href: 'https://www.wingie.co.uk/pt/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/pt/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/pt/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/pt/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/pt/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/pt/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-ro': [
        {
            title: 'Destinații principale',
            items: [
                { href: 'https://www.wingie.co.uk/ro/flights/to-dublin/', title: 'Dublin' },
                { href: 'https://www.wingie.co.uk/ro/flights/to-edinburgh/', title: 'Edinburgh' },
                { href: 'https://www.wingie.co.uk/ro/flights/to-belfast/', title: 'Belfast' },
                { href: 'https://www.wingie.co.uk/ro/flights/to-amsterdam/', title: 'Amsterdam' },
                { href: 'https://www.wingie.co.uk/ro/flights/to-new-york/', title: 'New York' },
                { href: 'https://www.wingie.co.uk/ro/flights/to-tenerife/', title: 'Tenerife' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { href: 'https://www.wingie.co.uk/ro/flights/be-belgium/', title: 'Belgia' },
                { href: 'https://www.wingie.co.uk/ro/flights/fr-france/', title: 'Franța' },
                { href: 'https://www.wingie.co.uk/ro/flights/de-germany/', title: 'Germania' },
                { href: 'https://www.wingie.co.uk/ro/flights/gr-greece/', title: 'Grecia' },
                { href: 'https://www.wingie.co.uk/ro/flights/in-india/', title: 'India' },
                { href: 'https://www.wingie.co.uk/ro/flights/ie-ireland/', title: 'Irlanda' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { href: 'https://www.wingie.co.uk/ro/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/ro/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/ro/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/ro/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/ro/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/ro/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-pl': [
        {
            title: 'Główne kierunki',
            items: [
                { href: 'https://www.wingie.co.uk/pl/flights/to-dublin/', title: 'Dublin' },
                { href: 'https://www.wingie.co.uk/pl/flights/to-edinburgh/', title: 'Edynburg' },
                { href: 'https://www.wingie.co.uk/pl/flights/to-belfast/', title: 'Belfast' },
                { href: 'https://www.wingie.co.uk/pl/flights/to-amsterdam/', title: 'Amsterdam' },
                { href: 'https://www.wingie.co.uk/pl/flights/to-new-york/', title: 'Nowy Jork' },
                { href: 'https://www.wingie.co.uk/pl/flights/to-tenerife/', title: 'Teneryfa' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { href: 'https://www.wingie.co.uk/pl/flights/be-belgium/', title: 'Belgia' },
                { href: 'https://www.wingie.co.uk/pl/flights/fr-france/', title: 'Francja' },
                { href: 'https://www.wingie.co.uk/pl/flights/de-germany/', title: 'Niemcy' },
                { href: 'https://www.wingie.co.uk/pl/flights/gr-greece/', title: 'Grecja' },
                { href: 'https://www.wingie.co.uk/pl/flights/in-india/', title: 'Indie' },
                { href: 'https://www.wingie.co.uk/pl/flights/ie-ireland/', title: 'Irlandia' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { href: 'https://www.wingie.co.uk/pl/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/pl/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/pl/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/pl/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/pl/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/pl/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-lt': [
        {
            title: 'Pagrindinės kryptys',
            items: [
                { href: 'https://www.wingie.co.uk/lt/flights/to-dublin/', title: 'Dublinas' },
                { href: 'https://www.wingie.co.uk/lt/flights/to-edinburgh/', title: 'Edinburgas' },
                { href: 'https://www.wingie.co.uk/lt/flights/to-belfast/', title: 'Belfastas' },
                { href: 'https://www.wingie.co.uk/lt/flights/to-amsterdam/', title: 'Amsterdamas' },
                { href: 'https://www.wingie.co.uk/lt/flights/to-new-york/', title: 'Niujorkas' },
                { href: 'https://www.wingie.co.uk/lt/flights/to-tenerife/', title: 'Tenerifė' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { href: 'https://www.wingie.co.uk/lt/flights/be-belgium/', title: 'Belgija' },
                { href: 'https://www.wingie.co.uk/lt/flights/fr-france/', title: 'Prancūzija' },
                { href: 'https://www.wingie.co.uk/lt/flights/de-germany/', title: 'Vokietija' },
                { href: 'https://www.wingie.co.uk/lt/flights/gr-greece/', title: 'Graikija' },
                { href: 'https://www.wingie.co.uk/lt/flights/in-india/', title: 'Indija' },
                { href: 'https://www.wingie.co.uk/lt/flights/ie-ireland/', title: 'Airija' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { href: 'https://www.wingie.co.uk/lt/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/lt/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/lt/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/lt/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/lt/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/lt/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-uz': [
        {
            title: "Asosiy yo'nalishlar",
            items: [
                { href: 'https://www.wingie.co.uk/uz/flights/to-dublin/', title: 'Dublin' },
                { href: 'https://www.wingie.co.uk/uz/flights/to-edinburgh/', title: 'Edinburg' },
                { href: 'https://www.wingie.co.uk/uz/flights/to-belfast/', title: 'Belfast' },
                { href: 'https://www.wingie.co.uk/uz/flights/to-amsterdam/', title: 'Amsterdam' },
                { href: 'https://www.wingie.co.uk/uz/flights/to-new-york/', title: 'Nyu-York' },
                { href: 'https://www.wingie.co.uk/uz/flights/to-tenerife/', title: 'Tenerife' },
            ],
        },
        {
            title: 'Mashhur mamlakatlar',
            items: [
                { href: 'https://www.wingie.co.uk/uz/flights/be-belgium/', title: 'Belgiya' },
                { href: 'https://www.wingie.co.uk/uz/flights/fr-france/', title: 'Fransiya' },
                { href: 'https://www.wingie.co.uk/uz/flights/de-germany/', title: 'Germaniya' },
                { href: 'https://www.wingie.co.uk/uz/flights/gr-greece/', title: 'Gretsiya' },
                { href: 'https://www.wingie.co.uk/uz/flights/in-india/', title: 'Hindiston' },
                { href: 'https://www.wingie.co.uk/uz/flights/ie-ireland/', title: 'Irlandiya' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { href: 'https://www.wingie.co.uk/uz/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/uz/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/uz/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/uz/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/uz/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/uz/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-sr': [
        {
            title: 'Главни правци',
            items: [
                { href: 'https://www.wingie.co.uk/sr/flights/to-dublin/', title: 'Даблин' },
                { href: 'https://www.wingie.co.uk/sr/flights/to-edinburgh/', title: 'Единбург' },
                { href: 'https://www.wingie.co.uk/sr/flights/to-belfast/', title: 'Белфаст' },
                { href: 'https://www.wingie.co.uk/sr/flights/to-amsterdam/', title: 'Амстердам' },
                { href: 'https://www.wingie.co.uk/sr/flights/to-new-york/', title: 'Њујорк' },
                { href: 'https://www.wingie.co.uk/sr/flights/to-tenerife/', title: 'Тенерифе' },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                { href: 'https://www.wingie.co.uk/sr/flights/be-belgium/', title: 'Белгија' },
                { href: 'https://www.wingie.co.uk/sr/flights/fr-france/', title: 'Француска' },
                { href: 'https://www.wingie.co.uk/sr/flights/de-germany/', title: 'Немачка' },
                { href: 'https://www.wingie.co.uk/sr/flights/gr-greece/', title: 'Грчка' },
                { href: 'https://www.wingie.co.uk/sr/flights/in-india/', title: 'Индија' },
                { href: 'https://www.wingie.co.uk/sr/flights/ie-ireland/', title: 'Ирска' },
            ],
        },
        {
            title: 'Популарне авио-компаније',
            items: [
                { href: 'https://www.wingie.co.uk/sr/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/sr/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/sr/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/sr/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/sr/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/sr/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-ky': [
        {
            title: 'Негизги багыттар',
            items: [
                { href: 'https://www.wingie.co.uk/ky/flights/to-dublin/', title: 'Дублин' },
                { href: 'https://www.wingie.co.uk/ky/flights/to-edinburgh/', title: 'Эдинбург' },
                { href: 'https://www.wingie.co.uk/ky/flights/to-belfast/', title: 'Белфаст' },
                { href: 'https://www.wingie.co.uk/ky/flights/to-amsterdam/', title: 'Амстердам' },
                { href: 'https://www.wingie.co.uk/ky/flights/to-new-york/', title: 'Нью-Йорк' },
                { href: 'https://www.wingie.co.uk/ky/flights/to-tenerife/', title: 'Тенерифе' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { href: 'https://www.wingie.co.uk/ky/flights/be-belgium/', title: 'Бельгия' },
                { href: 'https://www.wingie.co.uk/ky/flights/fr-france/', title: 'Франция' },
                { href: 'https://www.wingie.co.uk/ky/flights/de-germany/', title: 'Германия' },
                { href: 'https://www.wingie.co.uk/ky/flights/gr-greece/', title: 'Греция' },
                { href: 'https://www.wingie.co.uk/ky/flights/in-india/', title: 'Индия' },
                { href: 'https://www.wingie.co.uk/ky/flights/ie-ireland/', title: 'Ирландия' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { href: 'https://www.wingie.co.uk/ky/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/ky/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/ky/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/ky/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/ky/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/ky/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-tg': [
        {
            title: 'Самтҳои асосӣ',
            items: [
                { href: 'https://www.wingie.co.uk/tg/flights/to-dublin/', title: 'Дублин' },
                { href: 'https://www.wingie.co.uk/tg/flights/to-edinburgh/', title: 'Эдинбург' },
                { href: 'https://www.wingie.co.uk/tg/flights/to-belfast/', title: 'Белфаст' },
                { href: 'https://www.wingie.co.uk/tg/flights/to-amsterdam/', title: 'Амстердам' },
                { href: 'https://www.wingie.co.uk/tg/flights/to-new-york/', title: 'Ню-Йорк' },
                { href: 'https://www.wingie.co.uk/tg/flights/to-tenerife/', title: 'Тенерифе' },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                { href: 'https://www.wingie.co.uk/tg/flights/be-belgium/', title: 'Белгия' },
                { href: 'https://www.wingie.co.uk/tg/flights/fr-france/', title: 'Фаронса' },
                { href: 'https://www.wingie.co.uk/tg/flights/de-germany/', title: 'Олмон' },
                { href: 'https://www.wingie.co.uk/tg/flights/gr-greece/', title: 'Юнон' },
                { href: 'https://www.wingie.co.uk/tg/flights/in-india/', title: 'Ҳиндустон' },
                { href: 'https://www.wingie.co.uk/tg/flights/ie-ireland/', title: 'Ирландия' },
            ],
        },
        {
            title: 'Авиакомпанияҳои машҳур',
            items: [
                { href: 'https://www.wingie.co.uk/tg/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/tg/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/tg/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/tg/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/tg/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/tg/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-kk': [
        {
            title: 'Негізгі бағыттар',
            items: [
                { href: 'https://www.wingie.co.uk/kk/flights/to-dublin/', title: 'Дублин' },
                { href: 'https://www.wingie.co.uk/kk/flights/to-edinburgh/', title: 'Эдинбург' },
                { href: 'https://www.wingie.co.uk/kk/flights/to-belfast/', title: 'Белфаст' },
                { href: 'https://www.wingie.co.uk/kk/flights/to-amsterdam/', title: 'Амстердам' },
                { href: 'https://www.wingie.co.uk/kk/flights/to-new-york/', title: 'Нью-Йорк' },
                { href: 'https://www.wingie.co.uk/kk/flights/to-tenerife/', title: 'Тенерифе' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { href: 'https://www.wingie.co.uk/kk/flights/be-belgium/', title: 'Бельгия' },
                { href: 'https://www.wingie.co.uk/kk/flights/fr-france/', title: 'Франция' },
                { href: 'https://www.wingie.co.uk/kk/flights/de-germany/', title: 'Германия' },
                { href: 'https://www.wingie.co.uk/kk/flights/gr-greece/', title: 'Греция' },
                { href: 'https://www.wingie.co.uk/kk/flights/in-india/', title: 'Үндістан' },
                { href: 'https://www.wingie.co.uk/kk/flights/ie-ireland/', title: 'Ирландия' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { href: 'https://www.wingie.co.uk/kk/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/kk/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/kk/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/kk/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/kk/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/kk/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-nl': [
        {
            title: 'Populaire bestemmingen',
            items: [
                { href: 'https://www.wingie.co.uk/nl/flights/to-dublin/', title: 'Dublin' },
                { href: 'https://www.wingie.co.uk/nl/flights/to-edinburgh/', title: 'Edinburgh' },
                { href: 'https://www.wingie.co.uk/nl/flights/to-belfast/', title: 'Belfast' },
                { href: 'https://www.wingie.co.uk/nl/flights/to-amsterdam/', title: 'Amsterdam' },
                { href: 'https://www.wingie.co.uk/nl/flights/to-new-york/', title: 'New York' },
                { href: 'https://www.wingie.co.uk/nl/flights/to-tenerife/', title: 'Tenerife' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { href: 'https://www.wingie.co.uk/nl/flights/be-belgium/', title: 'België' },
                { href: 'https://www.wingie.co.uk/nl/flights/fr-france/', title: 'Frankrijk' },
                { href: 'https://www.wingie.co.uk/nl/flights/de-germany/', title: 'Duitsland' },
                { href: 'https://www.wingie.co.uk/nl/flights/gr-greece/', title: 'Griekenland' },
                { href: 'https://www.wingie.co.uk/nl/flights/in-india/', title: 'India' },
                { href: 'https://www.wingie.co.uk/nl/flights/ie-ireland/', title: 'Ierland' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { href: 'https://www.wingie.co.uk/nl/flights/airlines/british-airways/', title: 'British Airways' },
                { href: 'https://www.wingie.co.uk/nl/flights/airlines/easyjet/', title: 'easyJet' },
                { href: 'https://www.wingie.co.uk/nl/flights/airlines/ryanair/', title: 'Ryanair' },
                { href: 'https://www.wingie.co.uk/nl/flights/airlines/lufthansa/', title: 'Lufthansa' },
                { href: 'https://www.wingie.co.uk/nl/flights/airlines/eastern-airways/', title: 'Eastern Airways' },
                { href: 'https://www.wingie.co.uk/nl/flights/airlines/loganair/', title: 'Loganair' },
            ],
        },
    ],
    'gb-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.co.uk/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.co.uk/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.co.uk/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.co.uk/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.co.uk/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.co.uk/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.co.uk/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.co.uk/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.co.uk/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.co.uk/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.co.uk/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.co.uk/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.co.uk/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.co.uk/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.co.uk/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.co.uk/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.co.uk/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.co.uk/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.co.uk/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.co.uk/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.co.uk/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.co.uk/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.co.uk/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.co.uk/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.co.uk/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.co.uk/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.co.uk/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.co.uk/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.co.uk/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.co.uk/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.co.uk/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.co.uk/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.co.uk/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.co.uk/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.co.uk/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.co.uk/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.co.uk/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.co.uk/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.co.uk/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.co.uk/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.co.uk/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.co.uk/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.co.uk/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.co.uk/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.co.uk/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.co.uk/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.co.uk/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.co.uk/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.co.uk/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.co.uk/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.co.uk/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.co.uk/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.co.uk/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.co.uk/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.co.uk/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.co.uk/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.co.uk/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.co.uk/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.co.uk/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.co.uk/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.co.uk/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.co.uk/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.co.uk/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.co.uk/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.co.uk/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.co.uk/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.co.uk/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.co.uk/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.co.uk/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.co.uk/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.co.uk/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.co.uk/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.co.uk/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.co.uk/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.co.uk/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.co.uk/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.co.uk/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.co.uk/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.co.uk/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.co.uk/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.co.uk/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.co.uk/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.co.uk/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.co.uk/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.co.uk/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.co.uk/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.co.uk/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.co.uk/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.co.uk/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.co.uk/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.co.uk/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.co.uk/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.co.uk/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.co.uk/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.co.uk/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.co.uk/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.co.uk/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.co.uk/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.co.uk/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.co.uk/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.co.uk/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.co.uk/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.co.uk/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.co.uk/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.co.uk/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.co.uk/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.co.uk/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.co.uk/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.co.uk/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.co.uk/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.co.uk/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.co.uk/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.co.uk/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.co.uk/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.co.uk/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.co.uk/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.co.uk/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.co.uk/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.co.uk/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'gb-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.co.uk/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.co.uk/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.co.uk/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.co.uk/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.co.uk/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.co.uk/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.co.uk/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.co.uk/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.co.uk/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.co.uk/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.co.uk/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.co.uk/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.co.uk/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.co.uk/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.co.uk/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.co.uk/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.co.uk/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.co.uk/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}